import Blank from "@/layouts/blank.vue";
import DraftDAList from "@/pages/admin/draft-da/DraftDAList.vue";
import DraftDADetails from "@/pages/admin/draft-da/DraftDADetails.vue";

const draftDARoutes = [
  {
    path: "draft-da",
    name: "app-admin-draft-da",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/draft-da/list",
      },
      {
        path: "list",
        name: "app-admin-draft-da-list",
        component: DraftDAList,
      },
      {
        path: "details/:id",
        name: "app-admin-draft-da-details",
        component: DraftDADetails,
      },
    ],
  },
];

export default draftDARoutes;
